export const WHATSAPP_NUMBER = "5565981656252";

export const waLink = (message) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;

export const AGENCY = {
  name: "A.S.F Viagens",
  phoneDisplay: "+55 (65) 98165-6252",
  phoneSecondary: "+55 (65) 98165-6252",
  address: "R. Antônio Maria Coelho, 236 — Centro Norte, Cuiabá/MT · CEP 78005-420",
  hours: "Segunda a Sexta: 08h–18h · Sábado: 09h–13h",
  cnpj: "33.556.858/0001-96",
  email: "contato@asfviagens.com.br",
  domain: "www.asfviagens.com.br",
};

export const DEFAULT_WA_MESSAGE =
  "Olá, A.S.F Viagens! Vim pelo site e gostaria de atendimento.";
